import Button from "react-bootstrap/Button";
import './index.css'

interface OutlineButtonComponentProps {
    titel?: string;
    isDisabled?: boolean;
    type?: any;
    onClick?: any;
    icon?: any;
    colour?: string;
    style?: React.CSSProperties;
}

const OutlineButtonComponent: React.FC<OutlineButtonComponentProps> = ({
    titel,
    isDisabled,
    type,
    onClick,
    icon,
    colour
}) => {
    return (<>
        <Button className='buttonColor-Outline m-1 px-4' disabled={isDisabled} type={type} onClick={onClick}
            color={`${colour}`}>
            <div className="button-container-styles-outline">
                {icon} &nbsp;
                {titel}
            </div>
        </Button>
    </>)
}

export default OutlineButtonComponent;